module.exports = __webpack_public_path__ + "img/delete.bb0c4beb.png";